import * as tslib_1 from "tslib";
import { ComposeCommandingBar } from 'owa-mail-compose-view';
import { MailCommandingBar } from 'owa-mail-commandbar';
import { SecondaryReadingPaneTabCommandingBar } from 'owa-mail-reading-pane-view';
import { listViewStore } from 'owa-mail-list-store';
import { TabType } from 'owa-tab-store';
import isTabViewEnabled from 'owa-tab-store/lib/utils/isTabViewEnabled';
import ReadingPanePosition from 'owa-session-store/lib/store/schema/ReadingPanePosition';
import { composeStore } from 'owa-mail-compose-store';
import * as React from 'react';
import { observer } from 'mobx-react';
import strings from 'owa-strings/owa-mail-strings';
var styles = require('./MailModule.scss');
var MailCommandBarView = /** @class */ (function (_super) {
    tslib_1.__extends(MailCommandBarView, _super);
    function MailCommandBarView() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    MailCommandBarView.prototype.render = function () {
        return (React.createElement("div", { tabIndex: -1, className: styles.commandBar, role: 'region', "aria-label": strings.commandToolbarLabel }, this.renderCommandBar()));
    };
    MailCommandBarView.prototype.renderCommandBar = function () {
        var _a = this.props, activeTab = _a.activeTab, readingPanePosition = _a.readingPanePosition, listViewDimensions = _a.listViewDimensions, isDumpsterOrDumpsterSearchTable = _a.isDumpsterOrDumpsterSearchTable;
        var activeFullComposeViewState = this.getActiveFullComposeViewState();
        var isShowingFullSecondaryReadingPane = activeTab &&
            activeTab.type == TabType.SecondaryReadingPane &&
            readingPanePosition == ReadingPanePosition.Off;
        var commandBarStyle;
        if (activeFullComposeViewState && readingPanePosition == ReadingPanePosition.Right) {
            commandBarStyle = { paddingLeft: listViewDimensions.listViewWidth };
        }
        if (!isDumpsterOrDumpsterSearchTable &&
            /* Should never show compose command bar if in dumpster */ activeFullComposeViewState) {
            return (React.createElement(ComposeCommandingBar, { composeViewState: activeFullComposeViewState, styles: { root: commandBarStyle } }));
        }
        if (isShowingFullSecondaryReadingPane) {
            return React.createElement(SecondaryReadingPaneTabCommandingBar, { tab: activeTab });
        }
        return React.createElement(MailCommandingBar, { tableViewId: listViewStore.selectedTableViewId });
    };
    MailCommandBarView.prototype.getActiveFullComposeViewState = function () {
        if (isTabViewEnabled()) {
            var activeTab = this.props.activeTab;
            if (activeTab) {
                if (activeTab.type === TabType.Compose) {
                    return activeTab.data;
                }
                else if (activeTab.type == TabType.Primary &&
                    composeStore.defaultViewState &&
                    !composeStore.defaultViewState.isInlineCompose) {
                    // TODO: Remove this check once we fully enabled tab view
                    return composeStore.defaultViewState;
                }
            }
        }
        else if (composeStore.defaultViewState &&
            !composeStore.defaultViewState.isInlineCompose) {
            // TODO: Remove this check once we fully enabled tab view
            return composeStore.defaultViewState;
        }
        return null;
    };
    MailCommandBarView = tslib_1.__decorate([
        observer
    ], MailCommandBarView);
    return MailCommandBarView;
}(React.Component));
export default MailCommandBarView;
//# sourceMappingURL=MailCommandBarView.js.map